export const getSvgIconId = function (id: string | number): string {
    const idString = id?.toString();
    if (!idString) return '';

    return !isNaN(Number(idString.charAt(0))) ? `#symbol_${idString}` : `#${idString}`;
};
